import React from 'react';
import { Container, Title, Icon } from './styles';

const Placeholder: React.FC = () => {
  return (
    <Container>
      <Icon />
      <Title>You don’t have any comment yet</Title>
    </Container>
  );
};

export default Placeholder;

// TODO: TFR-29 add story to component
